import { useDispatch, useSelector } from 'react-redux';
import { redoPanelState } from 'store/slices/PanelSlice';
import { RootState } from 'store';
import { redoEditableFacets } from 'store/slices/RoofEditSlice';
import CustomRedoBtn from 'components/tool/Editor/ButtonDiv/RedoButton';

export default function UndoButton() {
	const dispatch = useDispatch();
	const { activePanelMode, currentIndex:panelHistoryCurrentIndex, panelHistory } = useSelector((state: RootState) => state.panelSlice.data);
	const { enableEditFacet, currentIndex:facetHistoryCurrentIndex, facetHistory} = useSelector((state: RootState) => state.roofEditData.data);
	const panelMode = activePanelMode && panelHistory.length > 0;
	const facetMode = enableEditFacet;
	const show = panelMode || facetMode;
	const shouldDisable = 
	(panelMode && panelHistoryCurrentIndex >= panelHistory.length - 1) || 
		(facetMode && facetHistoryCurrentIndex >= facetHistory.length - 1);
	
	function handleUndoClick() {
		if(panelMode) {
			dispatch(redoPanelState());
		}
		if(facetMode) {
			dispatch(redoEditableFacets());
		}
	}

	if (show) {
		return (
			<CustomRedoBtn
				id="redo-panel"
				disabled={shouldDisable}
				onClick={handleUndoClick}
			/>
		);
	}

	return null;

}